import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { getCloudinaryUrl } from 'core/classes/helpers'
import { calculateFileLink } from 'core/classes/helpers/saveFiles'
import { CrudHelper } from 'core/types/helpers/CrudHelper'

import styles from './Image.module.scss'

interface IProps {
  onChange: () => void
  item: IObjectAny
}

export const GalleryImage = ({ item, onChange }: IProps) => {
  const [loaded, setLoaded] = React.useState<boolean>(false)

  const deleteItem = async (item: IObjectAny) => {
    setLoaded(true)
    const crudHelper = new CrudHelper(504, 'CompanyPOSImages')
    await crudHelper.delete([item])
    onChange()
    setLoaded(false)
  }

  return (
    <div className={styles.imageWrapper}>
      <div className={styles.image}>
        <img
          src={getCloudinaryUrl({
            src:
              calculateFileLink({
                formId: 504,
                entryId: item.EntryId,
                fieldName: 'Image',
                fileName: item.Image || '',
                UID: item.UID,
              }) || '',
            width: 320,
            height: 240,
          })}
          alt=""
          className={styles.img}
        />
        {loaded && (
          <div className={styles.loaderWrapper}>
            <Loader className={styles.loader} />
          </div>
        )}
        <Button
          className={styles.iconEditWrapper}
          color={'danger'}
          iconButton={'kbase kbase-delete'}
          onClick={() => deleteItem(item)}
        />
      </div>
      <p>
        <Translation text={'image-image-should-be-*jpg,-*.jpeg-or-*png'} span />
      </p>
    </div>
  )
}
